<!-- Left side column. contains the logo and sidebar -->
<aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
        <!-- Sidebar user panel -->
        <div class="user-panel">
            <div class="pull-left image">
                <img src="./assets/images/user.png" class="img-circle" alt="User Image">
            </div>
            <div class="pull-left info">
                <p>{{ username }}</p>
                <a href="javascript:void(0)"><i class="fa fa-circle text-success"></i> Online</a>
            </div>
        </div>

        <form action="#" method="get" class="sidebar-form" [formGroup]="modelo" (ngSubmit)="abrirPesquisaPaciente()">
            <div class="e-input-group">
                <input class="e-input" type="text" style="width: 100%" formControlName="nomeCpf"
                    placeholder="Paciente nome/CPF..." />
                <span class="e-input-group-icon fa fa-search" (click)="abrirPesquisaPaciente()"></span>
            </div>
        </form>
        <!-- /.search form -->

        <!-- sidebar menu: : style can be found in sidebar.less -->
        <ul class="sidebar-menu" data-widget="tree">
            <li class="header">Menu</li>

            <li [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}">
                <a [routerLink]="'/'"><i class="fa fa-tachometer-alt"></i> <span>Início</span></a>
            </li>

            <li [routerLinkActive]="'active'">
                <a [routerLink]="'/agenda'"><i class="fas fa-calendar-plus"></i> <span>Minha Agenda</span></a>
            </li>

            <li [routerLinkActive]="'active'">
                <a [routerLink]="'/atendimentos-medicos'">
                    <i class="fas fa-files-medical"></i> 
                    <span>Atendimentos Médicos</span>
                    <span class="pull-right-container" *ngIf="mostrarTagAtualizacaoAtendimentos">
                        <small class="label pull-right bg-green-gradient">up</small>
                    </span>
                </a>
            </li>

            

            <li [routerLinkActive]="'active'">
                <a [routerLink]="'/exames'"><i class="fas fa-file-medical"></i> <span>Exames</span></a>
            </li>

            <li [routerLinkActive]="'active'">
                <a [routerLink]="'/atestados-medicos'"><i class="fas fa-history"></i> <span>Atestados Médicos</span></a>
            </li>

            <li class="treeview " [routerLinkActive]="'active menu-open'">
                <a href="#">
                    <i class="fa fa-file-alt"></i> 
                    <span>Modelos</span>
                    <span class="pull-right-container">
                        <i class="fa fa-angle-left pull-right"></i>
                        <small *ngIf="mostrarTagNovoModelos" class="label pull-right bg-green-gradient">novo</small>
                    </span>
                </a>
                <ul class="treeview-menu">
                    <li class="" [routerLinkActive]="'active'">
                        <a [routerLink]="'/modelos/historias'">História Clínica</a>
                    </li>
                </ul>
            </li>

            <li class="treeview " [routerLinkActive]="'active menu-open'">
                <a href="#">
                    <i class="fa fa-wrench"></i> 
                    <span>Configurações</span>
                    <span class="pull-right-container">
                        <i class="fa fa-angle-left pull-right"></i>
                        <small *ngIf="mostrarTagAtualizacaoConfiguracoes" class="label pull-right bg-green-gradient">up</small>
                    </span>
                </a>
                <ul class="treeview-menu">
                    <li class="" [routerLinkActive]="'active'">
                        <a [routerLink]="'/configuracoes/meu-usuario'">Meu Usuário</a>
                    </li>
                    <li class="separator"></li>
                    <li class="" [routerLinkActive]="'active'">
                        <a [routerLink]="'/configuracoes/meus-certificados'">Meus Certificados</a>
                    </li>
                    <li class="" [routerLinkActive]="'active'">
                        <a [routerLink]="'/configuracoes/certificados-locais'">Certificados Locais</a>
                    </li>
                    <li class="separator"></li>
                    <li class="" [routerLinkActive]="'active'">
                        <a [routerLink]="'/configuracoes/smoassinador'">SMOAssinador</a>
                    </li>
                </ul>
            </li>

            <li class="" [routerLinkActive]="'active'">
                <a [routerLink]="'/ajuda'" id="link_ajuda">
                    <i class="fa fa-question-circle"></i> <span>Ajuda</span>
                </a>
            </li>

            <li>
                <a href="#" (click)="$event.preventDefault()"  id="feedback-button"><i class="fa fas fa-bullhorn"></i> <span>Reportar Bug/Problema</span></a>
            </li>
        </ul>
    </section>
    <!-- /.sidebar -->
</aside>

<app-paciente-pesquisa #pacientePesquisa (registroSelecionado)="pacienteSelecionado($event)"></app-paciente-pesquisa>